import React, { FC, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  InformationTextCont,
  LogoutCont,
  WelcomeMessage,
  WelcomeMessageBold,
} from './Logout.styles';
import InformationText from '../../components/InformationText/InformationText';
import SubmitButton from '../../components/SubmitButton/SubmitButton';
import { RouteNames } from '../../constans/routes';
import { clearUserData } from '../../redux/slices/auth.slice';
import { logoutRequest } from '../../services/auth';

const Logout: FC = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const navigateToLoginPage = () => navigate(RouteNames.Login);

  useEffect(() => {
    (async () => {
      await logoutRequest();
      dispatch(clearUserData());
    })();
  }, []);

  return (
    <LogoutCont id="LogoutCont">
      <WelcomeMessage id="WelcomeMessage" data-testid="welcomeMessage">
        <WelcomeMessageBold id="WelcomeMessageBold">{t('logout.logout')}&nbsp;</WelcomeMessageBold>
        {t('logout.successful')}
      </WelcomeMessage>
      <InformationTextCont id="InformationTextCont" data-testid="informationTextCont">
        <InformationText text={t('logout.logoutMessage')} />
        <InformationText text={t('logout.aBitMore')} />
      </InformationTextCont>
      <div onClick={navigateToLoginPage}>
        <SubmitButton text={t('logout.logInAgain')} />
      </div>
    </LogoutCont>
  );
};

export default Logout;
